// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UzyFKEohJC8LXRv0{display:flex;flex-direction:row;justify-content:space-between;margin-top:14px;height:100%;align-items:center}.UzyFKEohJC8LXRv0 .Ax1IafSZAwkuOzrC{display:flex;flex-direction:row}.UzyFKEohJC8LXRv0 .Ax1IafSZAwkuOzrC .zCDtKO090lUkWu2y{font-size:56px;line-height:48px;font-weight:700}.UzyFKEohJC8LXRv0 .Ax1IafSZAwkuOzrC .ySERE1ivMQ8NDwVB{width:20px;display:flex;align-items:center;height:auto;margin-left:12px}.UzyFKEohJC8LXRv0 .Oh4XqMWegls5K2fs{margin-bottom:2px}.UzyFKEohJC8LXRv0 .KCPEfDl0kUb_TcGU{overflow:hidden;height:48px;flex-grow:1;max-width:106px;margin-left:16px}.wH0WcN6YHUHNpBUW{display:flex;align-items:center;justify-content:center;height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `UzyFKEohJC8LXRv0`,
	"leftContent": `Ax1IafSZAwkuOzrC`,
	"largeText": `zCDtKO090lUkWu2y`,
	"subText": `ySERE1ivMQ8NDwVB`,
	"dataText": `Oh4XqMWegls5K2fs`,
	"barChart": `KCPEfDl0kUb_TcGU`,
	"spinner": `wH0WcN6YHUHNpBUW`
};
export default ___CSS_LOADER_EXPORT___;
